<ew-mat-dialog-custom>
  <ew-mat-stepper-custom
    [sendIn]="'last'"
    [validations]="validations"
    [textForSendButton]="'transactions:buttonDelete'"
    [classForSendButton]="'warn'"
    (send)="deletePayment(paymentId)"
    [progressBar]="false">
    >
    <ew-mat-stepper-custom-step
      classContainer="text-center overflow-hidden"
      [title]="
        type === 'PAYMENT_REQUEST'
          ? 'paymentsDeletion:title'
          : type === 'COMMISSION'
          ? 'commissionsDelete:title'
          : 'invoiceFundsDelete:title'
      ">
      <main class="flex flex-col justify-between items-center">
        <treo-message
          class="text-left mt-5 w-full"
          [showIcon]="true"
          [showButtonClose]="false"
          [type]="'warn'"
          [appearance]="'outline'">
          <i treoMessageIcon class="fa-solid fa-triangle-exclamation"></i>
          <div class="flex flex-col font-medium">
            <span>{{
              type === 'PAYMENT_REQUEST'
                ? ('paymentsDeletion:actionUndonePaymentRequest' | translate)
                : type === 'COMMISSION'
                ? ('commissionsDelete:actionUndoneCommission' | translate)
                : ('paymentsDeletion:actionUndoneCorporatePayment' | translate)
            }}</span>
            <span
              *ngIf="
                type === 'PAYMENT_REQUEST' && isPayment(payment)
                  ? payment.platform !== 'Edvisor' &&
                    payment.platform !== 'EdWallet'
                  : false
              "
              >{{
                ('paymentsDeletion:genereateEFA' | translate).replace(
                  ':platform',
                  isPayment(payment) ? payment.platform : ''
                )
              }}</span
            >
          </div>
        </treo-message>

        <table *ngIf="payment" class="w-full my-10 text-left">
          <tr style="border: 1px solid lightgray">
            <th class="text-left py-3 px-5"># {{ 
              isCommission(payment) ? 'Commission Overview' : 'Payment Overview' 
            }}</th>
          </tr>
          <tbody style="border: 1px solid lightgray">
            <tr>
              <td class="px-5" [width]="250">{{
                isCommission(payment) ? 'Commission Id:' : 'Payment Id:'
              }}</td>
              <td>
                {{ getDisplayId() }}
              </td>
            </tr>

            <tr>
              <td class="px-5" [width]="250">Amount:</td>
              <td>
                {{ getAmountDisplay() }}
              </td>
            </tr>

            <tr *ngIf="isPayment(payment)">
              <td class="px-5" [width]="250">Student Name:</td>
              <td>
                {{
                  isPayment(payment)
                    ? payment.student?.firstname +
                      ' ' +
                      payment.student?.lastname
                    : ''
                }}
              </td>
            </tr>

            <tr *ngIf="isCommission(payment)">
              <td class="px-5" [width]="250">Invoice Number:</td>
              <td>
                {{ getInvoiceNumber() }}
              </td>
            </tr>

            <tr *ngIf="isCommission(payment)">
              <td class="px-5" [width]="250">Provider Name:</td>
              <td>
                {{ getProviderName() }}
              </td>
            </tr>

            <tr *ngIf="!isCommission(payment)">
              <td class="px-5" [width]="250">External Id:</td>
              <td>
                {{ getExternalId() }}
              </td>
            </tr>
          </tbody>
        </table>

        <mat-checkbox
          [disableRipple]="true"
          [formControl]="confirmation"
          ngClass="mt-5">
          <span> {{ 'paymentsDeletion:checkboxText' | translate }}</span>
        </mat-checkbox>
      </main>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
